import { useTrackPurchaseAnalytics } from '../../../hooks/bi/useTrackPurchaseAnalytics';
import { createHOCWithHookInside } from '../../createHOCWithHookInside';

/**
 * @deprecated use "useTrackPurchaseAnalytics" instead
 */
export const withPurchaseAnalytics = createHOCWithHookInside('withPurchaseAnalytics', useTrackPurchaseAnalytics);
